import React, { FC, MouseEvent } from 'react';
import { Link } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { PartyRow } from './interfaces/partyList';

interface PartyNameRendererProps extends ICellRendererParams {
  data: PartyRow;
  onPartyClick?: (fileId: string) => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    partyNameLink: {
      display: 'block',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      textAlign: 'left',
    },
  }),
);

const PartyNameRenderer: FC<PartyNameRendererProps> = ({ data, onPartyClick, node }) => {
  const classes = useStyles();

  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    if (onPartyClick && data) {
      onPartyClick(data.fileId);
    }
  };

  return (
    <Link
      component="button"
      variant="body2"
      onClick={handleClick}
      underline="always"
      data-testid={`party-verification-link-party-name-${node.rowIndex ?? 0}`}
      title={data.partyName}
      className={classes.partyNameLink}
    >
      {data.partyName}
    </Link>
  );
};

export default PartyNameRenderer;
